import { OperacaoFormularioCRUD } from "service/restricao/OperacaoFormulario/OperacaoFormulario"
import { Papel } from "service/restricao/Papeis"
import { CRUDSomenteVisualizacao, CRUDSemAcesso, CRUDSemRestricao, SomenteVisualizacao, SemRestricao, SemAcesso } from "service/restricao/PermissoesGenericas"
import { RestricaoCRUDFormulario } from "service/restricao/TipoRestricaoFormulario/RestricaoCRUDFormulario"

import { RestricoesCamposFormulario } from "../../service/restricao/RestricoesCamposFormulario"
import { RestricoesFormulario } from "../../service/restricao/RestricoesFormulario"


/**********************
  Permissões genéricas
 **********************/
const CRUDSomenteVisualizacaoECriacao = {
  [OperacaoFormularioCRUD.Visualizar]: SomenteVisualizacao,
  [OperacaoFormularioCRUD.Criar]: SemRestricao,
  [OperacaoFormularioCRUD.Atualizar]: SomenteVisualizacao,
}

/**********************
  Campos do formulário em que se aplica as restrições
 **********************/
interface CamposRestricoes extends RestricoesCamposFormulario {
  titulo: RestricaoCRUDFormulario;
  descricao: RestricaoCRUDFormulario;

  'classificacao.id': RestricaoCRUDFormulario;
  anexo: RestricaoCRUDFormulario;

  idSolicitante: RestricaoCRUDFormulario;

  // Select de situação
  'situacao.id': RestricaoCRUDFormulario;
  'prioridade.id': RestricaoCRUDFormulario;

  'unidadeResponsavel.id': RestricaoCRUDFormulario;
  'responsavelTecnico.id': RestricaoCRUDFormulario;
}


const UsuarioComum: Readonly<CamposRestricoes> = {
  titulo: CRUDSomenteVisualizacao,
  descricao: CRUDSomenteVisualizacao,

  'classificacao.id': CRUDSomenteVisualizacao,
  anexo: CRUDSomenteVisualizacao,

  idSolicitante: CRUDSomenteVisualizacao,

  'situacao.id': CRUDSemAcesso,
  'prioridade.id': CRUDSomenteVisualizacao,

  'unidadeResponsavel.id': CRUDSomenteVisualizacao,
  'responsavelTecnico.id': CRUDSomenteVisualizacao
}

const Nivel1: Readonly<CamposRestricoes> = {
  ...UsuarioComum,

  titulo: CRUDSomenteVisualizacaoECriacao,
  descricao: CRUDSomenteVisualizacaoECriacao,

  anexo: CRUDSomenteVisualizacaoECriacao,

  'classificacao.id': CRUDSemRestricao,
  idSolicitante: {
    [OperacaoFormularioCRUD.Visualizar]: SomenteVisualizacao,
    [OperacaoFormularioCRUD.Criar]: {...SemRestricao, clearable: true },
    [OperacaoFormularioCRUD.Atualizar]: SemRestricao,
  },

  'situacao.id': {
    // Não exibir no Formulário contexto, pois já aparece em baixo do título
    [OperacaoFormularioCRUD.Visualizar]: SemAcesso,
    [OperacaoFormularioCRUD.Criar]: SomenteVisualizacao,
    [OperacaoFormularioCRUD.Atualizar]: SemRestricao,
  },
  'prioridade.id': CRUDSemRestricao,

  'unidadeResponsavel.id': CRUDSemRestricao
}

const Nivel2: Readonly<CamposRestricoes> = {
  ...Nivel1,

  'responsavelTecnico.id': CRUDSemRestricao,
}

const Administrador: Readonly<CamposRestricoes> = {
  ...Nivel2,

  situacao: CRUDSemRestricao,
}

export const RestricoesSolicitacaoServicoFormulario: RestricoesFormulario<CamposRestricoes> = {
  [Papel.UsuarioComum]: UsuarioComum,
  [Papel.Nivel1]: Nivel1,
  [Papel.Nivel2]: Nivel2,
  [Papel.Administrador]: Administrador,
}
